export function formatAVHLV(string) {
  return string
    ? string
        .replace("_", " Fassung ")
        .replace(".pdf", "")
        .replace("/public/data/", "")
    : "";
}
